/**
 * Retorna a extensão de um arquivo em letras maiúsculas, sem o ponto.
 * Ex: "document.pdf" → "PDF"
 */
export const getFileExtension = (file: string) => {
  if (file) {
    const [fileExtension] = file.match(/\.[0-9a-z]+$/i);

    return fileExtension.slice(1).toUpperCase();
  }
};

/**
 * Remove a extensão de um arquivo.
 * Ex: "document.pdf" → "document"
 */
export const removeFileExtension = (file: string) => {
  if (file) {
    const extensionRemoved = file.replace(/\.[0-9a-z]+$/i, "");

    return extensionRemoved;
  }
};
